import { useState } from 'react';
import { MobileTooltip } from '@/theme/components/Tooltip/Tooltip';
import { Box, Text, Icons, Tooltip } from '@/theme/index';
import { useScreenSize } from '@/utils/index';
import { StyledBox } from '../components';

interface VINInformationProps {
  metaName?: string | JSX.Element;
  isClassicVin?: boolean | null;
  vinDecodeConfidenceScore?: number | null;
}

export const VINInformation = ({
  metaName,
  isClassicVin,
  vinDecodeConfidenceScore,
}: VINInformationProps) => {
  // HOOKS
  const { isMobile } = useScreenSize();

  // STATE
  const [vinTooltipOpen, setVinTooltipOpen] = useState(false);

  // FUNCTIONS
  const handleVinTooltipOpen = () => {
    setVinTooltipOpen(true);
  };
  const handleVinTooltipClose = () => {
    setVinTooltipOpen(false);
  };

  const confidenceScoreBox = (
    <StyledBox
      onClick={handleVinTooltipOpen}
      data-testid="confidence-vin-score"
    >
      <Text fontSize="0.875rem">{vinDecodeConfidenceScore}%</Text>
      <Text fontSize="0.875rem">Confidence</Text>
      <Icons.Info
        sx={{ color: 'primary.contrastText', fontSize: '1rem', m: 'auto 0' }}
      />
    </StyledBox>
  );

  const confidenceTooltipProps = {
    title:
      'Decoding VINs for pre-1981 vehicles may yield uncertain results due to non-standardized formats. We provide a confidence score (1-100) to indicate the reliability of the decoded information.',
    arrow: true,
  };

  const vinConfidenceLabel = isMobile ? (
    <MobileTooltip
      placement="top"
      {...confidenceTooltipProps}
      handleOnClose={handleVinTooltipClose}
      open={vinTooltipOpen}
    >
      {confidenceScoreBox}
    </MobileTooltip>
  ) : (
    <Tooltip placement="top" {...confidenceTooltipProps}>
      {confidenceScoreBox}
    </Tooltip>
  );

  return (
    <Box width="fit-content">
      {isClassicVin && vinConfidenceLabel}
      <Box display="flex" flexDirection="row" alignItems="center">
        {metaName}
      </Box>
    </Box>
  );
};
